import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface RevokeCertificationDialogData {
    certName: string;
    holderName: string;
    issuanceDate: string;
    action?: 'revoke' | 'suspend';
}

@Component({
    selector: 'app-dialog-revoke-certification',
    templateUrl: './dialog-revoke-certification.component.html',
    styleUrls: ['./dialog-revoke-certification.component.scss'],
    standalone: false
})
export class DialogRevokeCertificationComponent implements OnInit {
    form = new FormGroup({
        reason: new FormControl('', [Validators.required])
    });

    constructor(
        public dialogRef: MatDialogRef<DialogRevokeCertificationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RevokeCertificationDialogData
    ) { }

    ngOnInit(): void { }

    onConfirm(): void {
        if (this.form.valid) {
            this.dialogRef.close(this.form.get('reason').value);
        }
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }
}
